export class Categorie {
  id: number;
  categoria: string;
  figli: Categorie[];
  cat_id: number;
}
